document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-extended-desc-trigger]').forEach(function (trigger) {
    var dialog = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!dialog) return;

    var closeBtn = dialog.querySelector('[data-extended-desc-close]');

    function openDialog() {
      dialog.showModal(); // native focus trap + top-layer + Escape-to-close
      trigger.setAttribute('aria-expanded', 'true');
    }

    function closeDialog() {
      dialog.close();
    }

    trigger.addEventListener('click', openDialog);
    closeBtn.addEventListener('click', closeDialog);

    dialog.addEventListener('close', function () {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus();
    });

    // click on backdrop closes it (click target === dialog itself, not inner content)
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) closeDialog();
    });
  });
});